import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { ProjectView, getProjectOptions } from '@/module/Author/Project';

export const Route = createFileRoute('/_auth/author/_author/project/_project/$projectId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { projectId } = Route.useParams();
  const { data: project } = useSuspenseQuery(getProjectOptions(projectId));

  return <ProjectView project={project} />;
}
